import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { environment} from '../../../../../../environments/environment';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { OfferOptionGroupInterface } from '../../../models/offer-option-group.interface';
import { OfferVitrineService } from '../../../services/offer-vitrine.service';
import { SaveMission } from '../../../store/actions/mission.actions';
import { OfferDetailsInterface } from '../../../models/offer-details.interface';
import { ConstsHelper } from '../../../../../helpers/consts.helper';
import { GetAlertMessage } from '../../../store/actions/alert-message.actions';
import { AlertMessageInterface } from '../../../models/alert-message.interface';

@Component({
  selector: 'app-handle-line-options',
  templateUrl: './handle-line-options.component.html',
  styleUrls: ['./handle-line-options.component.css'],
  standalone: false
})
export class HandleLineOptionsComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;
  brand?: string;
  selectedOfferDetails: OfferDetailsInterface|null;
  selectedOptions = [];
  submitted: boolean;
  invalidOptions: boolean;
  phoneNumber: string;
  errorClassName: string;
  engagementOptionGroup: any;
  endDateSuisse: string = null;
  endDateVoyage: string = null;
  endDateSuisseOption = false;
  endDateVoyageOption = false;
  errorMessageSuisse: string|null;
  errorMessageVoyage: string|null;
  suisseOption = 'Option Suisse';
  tripOption = 'Option Voyage';

  constructor(
      private store: Store<any>,
      private offerVitrineService: OfferVitrineService
  ) { }

  ngOnInit() {
    this.brand = environment.data.brand;
    this.selectedOfferDetails = null;
    this.selectedOptions = [];
    this.engagementOptionGroup = null;
    this.errorMessageSuisse = null;
    this.errorMessageVoyage = null;
    if (this.line.status.toLowerCase() === 'active' || this.line.statusCode === 'PARTIAL_SUSPENSION') {
      // retrieves current customer line details & options
      // @ts-ignore
      this.offerVitrineService.getOfferDetails(this.line.offer.id, true).subscribe( response => {
        this.selectedOfferDetails = response;
        // simple options => checkbox
        for (const option of this.selectedOfferDetails.options_fmt.stand_alone_options) {
          if (
              // tslint:disable-next-line:triple-equals
              option.show_on_change_options == true &&
              !this.addSelectedOption(option.option_id, option.label_ec, true, true, null, null) &&
              (
                  option.requirement === 'mandatory' ||
                  (option.group_label && option.group_label.toLowerCase() === 'promo')
              )
          ) {
            this.selectedOptions.push({
              groupOptionId: null,
              id: option.option_id,
              label: option.label_ec,
              labelGroup: null,
              active: true,
              existOnLine: true
            });
          }
        }
        // options group => radio button
        for (const optionGroup of this.selectedOfferDetails.options_fmt.option_groups) {
          if (this.showOptionsGroup(this.selectedOfferDetails.options_fmt.option_groups, optionGroup.id)) {
            for (const option of optionGroup.options) {
              this.addSelectedOption(option.option_id, option.label_ec, true, true, optionGroup.id, optionGroup.label);
            }
          }
        }
      }, error => {
        const alertMessage = { message: ConstsHelper.ERROR_OCCURRED_RETRY_MESSAGE, code: 400 } as AlertMessageInterface;
        this.store.dispatch(new GetAlertMessage(alertMessage));
        this.cancel();
      });
    }
  }

  confirmation(): void {
    this.submitted = true;
    this.invalidOptions = false;
    this.errorClassName = '';
    this.errorMessageSuisse = null;
    this.errorMessageVoyage = null;
    const options = [];
    for (const option of this.selectedOptions) {
      let op = {
        id: option.id,
        active: option.active,
      } as any;
      if (option.labelGroup) {
        // tslint:disable-next-line:triple-equals
        if (option.labelGroup.toLowerCase() == this.suisseOption.toLowerCase() && ['', null].indexOf(this.endDateSuisse) == -1) {
          if ( ConstsHelper.frenchDatePattern.test(this.endDateSuisse)) {
            op = {...op, end_date: this.formatDate(this.endDateSuisse, '/', '-')};
          } else {
            this.errorMessageSuisse = 'La date doit être au format jj/mm/aaaa';
          }
        }
        // tslint:disable-next-line:triple-equals
        if (option.labelGroup.toLowerCase() == this.tripOption.toLowerCase() && ['', null].indexOf(this.endDateVoyage) == -1) {
          if ( ConstsHelper.frenchDatePattern.test(this.endDateVoyage)) {
            op = {...op, end_date: this.formatDate(this.endDateVoyage, '/', '-')};
          } else {
            this.errorMessageVoyage = 'La date doit être au format jj/mm/aaaa';
          }
        }
      }
      options.push(op);
    }
    this.store.dispatch(new SaveMission({phoneNumber: this.line.phoneNumber, options}, this.procedureCode));
  }
  formatDate(myDate: string | null, splitSeparator: string, separator: string) {
    let result = '';
    if (myDate) {
      const splitDate = myDate.split(splitSeparator);
      if (splitDate.length === 3) {
        result = splitDate[2] + separator + splitDate[1] + separator + splitDate[0];
      }
    }

    return result;
  }

  cancel(): void {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }
  addSelectedOption(
      id: number,
      label: string,
      active: boolean,
      existOnLine: boolean,
      groupOptionId: number|null,
      groupLabel: string|null,
  ) {
    if (!this.isSelected(id) && this.line.options.findIndex((obj) => obj.id === id) !== -1) {
      this.selectedOptions.push({
        groupOptionId,
        id,
        label,
        labelGroup: groupLabel,
        active,
        existOnLine
      });
      return true;
    }
    return false;
  }
  setSelectedOptions(
      $event,
      id: number,
      label: string,
      groupOptionId: number|null,
      groupLabel: string|null,
  ) {
    const optionIndex = this.selectedOptions.findIndex((obj) => obj.id === id);
    if (groupOptionId == null) {
      // tslint:disable-next-line:triple-equals
      if ($event.target.checked && optionIndex == -1) {
        this.selectedOptions.push({
          groupOptionId,
          id,
          label,
          labelGroup: groupLabel,
          active: true,
          existOnLine: false,
        });
      } else if ($event.target.checked && optionIndex !== -1) {
        this.selectedOptions[optionIndex].active = true;
      } else if (!$event.target.checked && optionIndex !== -1 && !this.selectedOptions[optionIndex].existOnLine) {
        this.selectedOptions.splice(optionIndex, 1);
      } else if (!$event.target.checked && optionIndex !== -1 && this.selectedOptions[optionIndex].existOnLine) {
        this.selectedOptions[optionIndex].active = false;
      }
    } else {
      // tslint:disable-next-line:triple-equals max-line-length
      const originalGroupOptionIndex = this.selectedOptions.findIndex((obj) => (obj.groupOptionId === groupOptionId && obj.existOnLine == true));
      // tslint:disable-next-line:triple-equals max-line-length
      const selectedGroupOptionIndex = this.selectedOptions.findIndex((obj) => (obj.groupOptionId === groupOptionId && obj.existOnLine == false));
      // tslint:disable-next-line:triple-equals
      if (originalGroupOptionIndex == -1 && selectedGroupOptionIndex == -1 && optionIndex == -1) {
        this.selectedOptions.push({
          groupOptionId,
          id,
          label,
          labelGroup: groupLabel,
          active: true,
          existOnLine: false,
        });
        if (groupLabel.toLowerCase() === this.suisseOption.toLowerCase()) {
          this.endDateSuisseOption = true;
        }
        if (groupLabel.toLowerCase() === this.tripOption.toLowerCase()) {
          this.endDateVoyageOption = true;
        }
      } else if (originalGroupOptionIndex !== -1 && selectedGroupOptionIndex === -1 && optionIndex === -1) {
        this.selectedOptions[originalGroupOptionIndex].active = false;
        this.selectedOptions.push({
          groupOptionId,
          id,
          label,
          labelGroup: groupLabel,
          active: true,
          existOnLine: false,
        });
      } else if (originalGroupOptionIndex !== -1 && selectedGroupOptionIndex !== -1 && originalGroupOptionIndex === optionIndex) {
        this.selectedOptions[originalGroupOptionIndex].active = true;
        this.selectedOptions.splice(selectedGroupOptionIndex, 1);
      } else if (originalGroupOptionIndex !== -1 && selectedGroupOptionIndex !== -1 && originalGroupOptionIndex !== optionIndex) {
        this.selectedOptions[originalGroupOptionIndex].active = false;
        this.selectedOptions.splice(selectedGroupOptionIndex, 1);
        this.selectedOptions.push({
          groupOptionId,
          id,
          label,
          labelGroup: groupLabel,
          active: true,
          existOnLine: false,
        });
      } else {
        this.selectedOptions.splice(selectedGroupOptionIndex, 1);
        this.selectedOptions.push({
          groupOptionId,
          id,
          label,
          labelGroup: groupLabel,
          active: true,
          existOnLine: false,
        });
        if (groupLabel.toLowerCase() === this.suisseOption.toLowerCase()) {
          this.endDateSuisseOption = true;
        }
        if (groupLabel.toLowerCase() === this.tripOption.toLowerCase()) {
          this.endDateVoyageOption = true;
        }
      }
    }
  }

  isSelected(id: number) {
    return this.selectedOptions.findIndex((obj) => obj.id === id) !== -1;
  }
  showOptionsGroup(optionGroups: Array<OfferOptionGroupInterface>, id: number) {
    for (const options of optionGroups) {
      if (options.id === id) {
        for (const option of options.options) {
          if (option.show_on_change_options === true) {
            return true;
          }
        }
      }
    }
    return false;
  }
}
